@charset "UTF-8";
.daracl-form {
  --border-color: #dfe1e5;
  --color-danger: #d9534f;
  --background-danger: #d9534f;
  --font-color: #686868;
  --font-hover-color: #3a3d41;
  --invalid-font-color: #ff4136;
  --invalid-border-color: #ffb6b4;
  --invalid-background-color: #fdd;
  --button-bg: #f6f6f6;
  --button-bg-hover: #ebebeb;
  --tab-bg: #f6f6f6;
  --tab-bg-hover: #ebebeb;
  --tooltip-background: #3e3e3e;
  --tooltip-color: #fff;
  --field-margin-top: 10px;
  --input-bg: #fff;
  --input-color: #212529;
  --input-disabled-bg: #ebebeb;
  --bg-grid-header: #f1f1f1;
}

body.dark .daracl-form,
.daracl-form.dark {
  --border-color: #41444c;
  --color-danger: #d9534f;
  --background-danger: #d9534f;
  --font-color: #b9bdc1;
  --font-hover-color: #f5f3f3;
  --invalid-font-color: #ff4136;
  --invalid-border-color: #ffb6b4;
  --invalid-background-color: #fdd;
  --button-bg: #435ebe;
  --button-bg-hover: #3950a2;
  --tab-bg: #23418f;
  --tab-bg-hover: #516db1;
  --tooltip-background: #3e3e3e;
  --tooltip-color: #fff;
  --field-margin-top: 10px;
  --input-bg: transparent;
  --input-color: #c6cddb;
  --input-disabled-bg: #878787;
  --bg-grid-header: #878787;
}

.daracl-form {
  padding: 0px;
  margin-top: 10px;
  color: var(--font-color);
}
.daracl-form *,
.daracl-form ::after,
.daracl-form ::before {
  box-sizing: border-box;
}
.daracl-form .txt-left {
  text-align: left;
}
.daracl-form .txt-center {
  text-align: center;
}
.daracl-form .txt-right {
  text-align: right;
}
.daracl-form[data-df-mode=view] .form-field {
  border-width: 0px;
  border-color: transparent;
  border-color: transparent;
  outline: initial;
}
.daracl-form[data-df-mode=view] .form-field:focus-visible, .daracl-form[data-df-mode=view] .form-field:focus {
  border-width: 0px;
}
.daracl-form .df-hidden {
  max-height: 0vh !important;
  width: 0px;
  visibility: collapse;
  display: none !important;
  padding: 0px !important;
  margin: 0px !important;
}
.daracl-form input,
.daracl-form select,
.daracl-form textarea {
  background-color: transparent;
  color: var(--font-color);
}
.daracl-form input[disabled],
.daracl-form select[disabled],
.daracl-form textarea[disabled] {
  background-color: var(--input-disabled-bg);
  opacity: 0.8;
}
.daracl-form .df-label {
  position: relative;
  font-weight: 700;
  vertical-align: top;
  padding: 5px 15px 0px 0px;
  overflow: initial;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
}
.daracl-form .df-label .required {
  color: var(--color-danger);
}
.daracl-form .df-label .required::after {
  content: "*";
  vertical-align: middle;
}
.daracl-form .df-label .df-tooltip {
  visibility: visible;
  color: var(--tooltip-color);
  background: var(--tooltip-background);
  width: 16px;
  height: 16px;
  border-radius: 8px;
  text-align: center;
  line-height: 16px;
  margin: 0 5px;
  font-size: 12px;
  cursor: help;
  position: relative;
  display: inline-block;
}
.daracl-form .df-label .df-tooltip .tooltip {
  display: none;
  text-align: initial;
  background: var(--tooltip-background);
  border-radius: 5px;
  color: var(--tooltip-color);
  padding: 10px 5px;
  position: absolute;
  z-index: 2;
  left: -10px;
  min-width: max-content;
  text-shadow: none;
  cursor: default;
}
.daracl-form .df-label .df-tooltip:hover .tooltip {
  display: block;
}
.daracl-form .form-field {
  border: 1px solid var(--border-color);
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: var(--input-bg);
  background-clip: padding-box;
  color: var(--input-color);
}
.daracl-form .form-field[type=radio], .daracl-form .form-field[type=checkbox] {
  width: 14px;
  display: inline;
  min-height: 0px;
  padding: 0px;
  margin: 0px;
  vertical-align: middle;
}
.daracl-form .form-field.dropdown {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.daracl-form .form-field.textarea {
  padding-right: 0px;
}
.daracl-form .form-field[type=number] {
  padding-right: 3px;
}
.daracl-form .form-field.file {
  display: none;
}
.daracl-form .form-field.range {
  padding: 0px;
}
.daracl-form .df-row {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex: 0 1 auto;
  -webkit-box-flex: 0;
  flex: 0 1 auto;
  -ms-flex-direction: row;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.daracl-form .df-row.vertical {
  display: block;
}
.daracl-form .df-row.horizontal {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}
.daracl-form .df-row.horizontal > .form-group > .empty {
  display: none !important;
}
.daracl-form .df-row.top {
  flex-direction: column;
}
.daracl-form .df-row.top > div {
  max-width: 100% !important;
}
.daracl-form .df-row.right {
  -ms-flex-direction: row-reverse !important;
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: reverse !important;
  flex-direction: row-reverse !important;
}
.daracl-form .df-row.bottom {
  flex-direction: column-reverse !important;
}
.daracl-form .df-row.bottom > div {
  max-width: 100% !important;
}
.daracl-form .col-xs-1 {
  flex-basis: 8.33333333%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.33333333%;
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}
.daracl-form .col-xs-2 {
  flex-basis: 16.66666667%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666667%;
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}
.daracl-form .col-xs-3 {
  flex-basis: 25%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}
.daracl-form .col-xs-4 {
  flex-basis: 33.33333333%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333%;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
.daracl-form .col-xs-5 {
  flex-basis: 41.66666667%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666667%;
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}
.daracl-form .col-xs-6 {
  flex-basis: 50%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}
.daracl-form .col-xs-7 {
  flex-basis: 58.33333333%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333%;
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}
.daracl-form .col-xs-8 {
  flex-basis: 66.66666667%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666667%;
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}
.daracl-form .col-xs-9 {
  flex-basis: 75%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}
.daracl-form .col-xs-10 {
  flex-basis: 83.33333333%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333%;
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}
.daracl-form .col-xs-11 {
  flex-basis: 91.66666667%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666667%;
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}
.daracl-form .col-xs-12 {
  flex-basis: 100%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
.daracl-form .align-items-center {
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}
.daracl-form .col-xs {
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  -webkit-box-flex: 1;
  flex-grow: 1;
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  max-width: 100%;
}
.daracl-form .col-auto {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}
.daracl-form .col-fix {
  flex: none;
}
.daracl-form .col-full {
  flex: 1;
  overflow: auto;
}
.daracl-form .df-field-container {
  overflow: initial;
  position: relative;
}
.daracl-form .df-field-container > .df-row {
  margin-top: -10px;
}
.daracl-form .df-field-container > div + .df-row {
  margin-top: 0px;
}
.daracl-form .df-field-container .df-field {
  position: relative;
  margin-right: 10px;
}
.daracl-form .df-field-container .df-field .range-num {
  clear: both;
  display: block;
  width: 100%;
  text-align: left;
}
.daracl-form .df-field-container .df-field .file-wrapper {
  border: 1px solid var(--border-color);
  text-align: center;
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.daracl-form .daracl-file-list .file-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
.daracl-form .daracl-file-list .file-icon:hover {
  background-color: var(--button-bg-hover);
}
.daracl-form .daracl-file-list .file-icon.download {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjIwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjIwcHgiIGZpbGw9IiMwMDAwMDAiPjxnPjxyZWN0IGZpbGw9Im5vbmUiIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIvPjwvZz48Zz48cGF0aCBkPSJNMTgsMTV2M0g2di0zSDR2M2MwLDEuMSwwLjksMiwyLDJoMTJjMS4xLDAsMi0wLjksMi0ydi0zSDE4eiBNMTcsMTFsLTEuNDEtMS40MUwxMywxMi4xN1Y0aC0ydjguMTdMOC40MSw5LjU5TDcsMTFsNSw1IEwxNywxMXoiLz48L2c+PC9zdmc+");
}
.daracl-form .daracl-file-list .file-icon.remove {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjBweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjBweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE2IDl2MTBIOFY5aDhtLTEuNS02aC01bC0xIDFINXYyaDE0VjRoLTMuNWwtMS0xek0xOCA3SDZ2MTJjMCAxLjEuOSAyIDIgMmg4YzEuMSAwIDItLjkgMi0yVjd6Ii8+PC9zdmc+");
}
.daracl-form .daracl-file-list .file-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 55px);
}
.daracl-form .field-group .field.vertical > * {
  display: block;
}
.daracl-form .tab-header {
  list-style: none;
  margin: 0px;
  padding: 0px;
  display: flex;
  line-height: 1.3;
  width: 100%;
  border-bottom: 1px solid var(--border-color);
}
.daracl-form .tab-header.tab-al-left {
  justify-content: left;
}
.daracl-form .tab-header.tab-al-right {
  justify-content: right;
}
.daracl-form .tab-header.tab-al-center {
  justify-content: center;
}
.daracl-form .tab-header > .tab-item {
  list-style: none;
  float: left;
  position: relative;
  top: 0;
  margin: 1px 0.4em 0 0;
  padding: 0;
  white-space: nowrap;
}
.daracl-form .tab-header > .tab-item.active a {
  color: var(--font-hover-color);
  background-color: var(--tab-bg);
}
.daracl-form .tab-header > .tab-item a {
  border-top-left-radius: calc(0.45rem - 1px);
  border-top-right-radius: calc(0.45rem - 1px);
  border: 1px solid transparent;
  border-bottom-width: 0;
  float: left;
  padding: 0.5em 1em;
  text-decoration: none;
  color: var(--font-color);
  height: 30px;
  line-height: 15px;
}
.daracl-form .tab-header > .tab-item a:hover {
  background-color: var(--tab-bg-hover);
  border: 1px solid var(--border-color);
  border-bottom-width: 0;
}
.daracl-form .df-tab-body .tab-panel {
  display: none;
}
.daracl-form .df-tab-body .tab-panel.active {
  display: block;
}
.daracl-form .df-btn {
  padding: 5px 10px;
  border-radius: calc(0.45rem - 1px);
  border: 1px solid var(--border-color);
  background-color: var(--button-bg);
  cursor: pointer;
  transition: background-color 0.3s;
}
.daracl-form .df-btn:hover {
  color: var(--font-hover-color);
  background-color: var(--button-bg-hover);
}
.daracl-form .df-icon {
  display: inline-block;
  width: 21px; /* 아이콘의 너비 설정 */
  height: 21px; /* 아이콘의 높이 설정 */
  vertical-align: middle;
}
.daracl-form .df-add-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='20px' viewBox='0 -960 960 960' width='20px' fill='%235f6368'%3E%3Cpath d='M431-431H220.78v-98H431v-210.22h98V-529h210.22v98H529v210.22h-98V-431Z'/%3E%3C/svg%3E");
}
.daracl-form .df-remove-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='20px' viewBox='0 -960 960 960' width='20px' fill='%235f6368'%3E%3Cpath d='M291-221.91 221.91-291l189-189-189-189L291-738.09l189 189 189-189L738.09-669l-189 189 189 189L669-221.91l-189-189-189 189Z'/%3E%3C/svg%3E");
}
.daracl-form .form-group {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: row;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: var(--field-margin-top);
  margin-bottom: 0px;
  margin-right: 0px !important;
  margin-left: 0px !important;
}
.daracl-form .form-group:last-child {
  margin-bottom: 0px;
}
.daracl-form .form-group.top {
  flex-direction: column;
}
.daracl-form .form-group.top > div {
  max-width: 100% !important;
}
.daracl-form .form-group.right {
  -ms-flex-direction: row-reverse !important;
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: reverse !important;
  flex-direction: row-reverse !important;
}
.daracl-form .form-group.bottom {
  flex-direction: column-reverse !important;
}
.daracl-form .form-group.bottom > div {
  max-width: 100% !important;
}
.daracl-form .form-group .help-message {
  display: none;
}
.daracl-form .form-group .help-icon {
  background-repeat: no-repeat;
  background-position-y: center;
}
.daracl-form .form-group .help-icon.form-field {
  background-position-x: calc(100% - 15px);
}
.daracl-form .form-group .help-icon.daracl-icon {
  display: none;
  position: absolute;
  z-index: 1;
  top: 0px;
  right: 0px;
  height: 100%;
  width: 20px;
  margin-right: 15px;
}
.daracl-form .form-group.invalid .form-field {
  border-color: var(--invalid-border-color);
  outline-color: var(--invalid-border-color);
}
.daracl-form .form-group.invalid > .df-field-container.required > .df-field .help-icon {
  display: block;
  background-image: url("data:image/svg+xml; base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjAiPjxwYXRoIGQ9Im0yNDktMjA3LTQyLTQyIDIzMS0yMzEtMjMxLTIzMSA0Mi00MiAyMzEgMjMxIDIzMS0yMzEgNDIgNDItMjMxIDIzMSAyMzEgMjMxLTQyIDQyLTIzMS0yMzEtMjMxIDIzMVoiIHN0eWxlPSImIzEwOyAgICBmaWxsOiAjZmY3MzczOyYjMTA7Ii8+PC9zdmc+");
}
.daracl-form .form-group.invalid .help-message {
  display: block;
  color: var(--invalid-font-color);
}
.daracl-form .form-group.valid > .df-field-container.required > .df-field .help-icon {
  display: block;
  background-image: url("data:image/svg+xml; base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHN0eWxlPSImIzEwOyAgICBmaWxsOiAjMTlhOTc0OyYjMTA7Ij48cGF0aCBkPSJNMzc4LTI0NiAxNTQtNDcwbDQzLTQzIDE4MSAxODEgMzg0LTM4NCA0MyA0My00MjcgNDI3WiIvPjwvc3ZnPg==");
}
.daracl-form .form-group .file-label {
  border: 1px solid var(--border-color);
  display: inline;
  width: 100%;
  padding: 3px 15px;
  line-height: 1;
  background-clip: padding-box;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.daracl-form .form-group .file-label:hover {
  background-color: var(--button-bg-hover);
}
.daracl-form .df-grid-field {
  margin-right: 10px;
}
.daracl-form .df-grid-field .df-grid-btn-area {
  border: 1px solid var(--border-color);
  padding: 3px;
}
.daracl-form .df-grid-field .df-grid-container {
  width: 100%;
  height: auto;
  overflow-y: auto;
  border: 1px solid var(--border-color);
}
.daracl-form .df-grid-field .df-grid-container .df-btn {
  padding: 3px 5px;
}
.daracl-form .df-grid-field .df-grid-container .df-grid {
  width: 100%;
  border-top-width: 0px;
  border-collapse: collapse;
}
.daracl-form .df-grid-field .df-grid-container .df-grid > thead th {
  position: sticky;
  top: 0px;
  z-index: 10;
  border-bottom: 1px solid var(--border-color);
  background-color: var(--bg-grid-header);
  text-align: center;
}
.daracl-form .df-grid-field .df-grid-container .df-grid .help-message {
  display: none;
}
.daracl-form .df-grid-field .df-grid-container .df-grid td,
.daracl-form .df-grid-field .df-grid-container .df-grid th {
  padding: 3px 5px;
}
.daracl-form .df-grid-field .df-grid-container .df-grid .help-icon {
  background-repeat: no-repeat;
  background-position-y: center;
}
.daracl-form .df-grid-field .df-grid-container .df-grid .help-icon.form-field {
  background-position-x: calc(100% - 15px);
}
.daracl-form .df-grid-field .df-grid-container .df-grid .help-icon.daracl-icon {
  display: none;
  position: absolute;
  z-index: 1;
  top: 0px;
  right: 0px;
  height: 100%;
  width: 20px;
  margin-right: 15px;
}
.daracl-form .df-grid-field .df-grid-container .df-grid .grid-column {
  position: relative;
}
.daracl-form .df-grid-field .df-grid-container .df-grid .invalid .form-field {
  border-color: var(--invalid-border-color);
  outline-color: var(--invalid-border-color);
}
.daracl-form .df-grid-field .df-grid-container .df-grid .invalid > .grid-column.required .df-field .help-icon {
  display: block;
  background-image: url("data:image/svg+xml; base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjAiPjxwYXRoIGQ9Im0yNDktMjA3LTQyLTQyIDIzMS0yMzEtMjMxLTIzMSA0Mi00MiAyMzEgMjMxIDIzMS0yMzEgNDIgNDItMjMxIDIzMSAyMzEgMjMxLTQyIDQyLTIzMS0yMzEtMjMxIDIzMVoiIHN0eWxlPSImIzEwOyAgICBmaWxsOiAjZmY3MzczOyYjMTA7Ii8+PC9zdmc+");
}
.daracl-form .df-grid-field .df-grid-container .df-grid .invalid .help-message {
  display: block;
  position: absolute;
  border: 1px solid var(--invalid-border-color);
  border-color: var(--invalid-border-color) transparent transparent transparent;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 270px;
  padding: 5px 5px;
  border-radius: 0.4rem;
  z-index: 2;
  background-color: var(--invalid-background-color);
  color: var(--invalid-font-color);
}
.daracl-form .df-grid-field .df-grid-container .df-grid .invalid .help-message::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  width: 0;
  height: 0;
  border: 7px solid transparent;
  border-bottom-color: var(--invalid-border-color);
  border-top: 0;
  border-left: 0;
  margin-left: -3.5px;
  margin-top: -7px;
}
.daracl-form .df-grid-field .df-grid-container .df-grid .valid > .grid-column.required .df-field .help-icon {
  display: block;
  background-image: url("data:image/svg+xml; base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHN0eWxlPSImIzEwOyAgICBmaWxsOiAjMTlhOTc0OyYjMTA7Ij48cGF0aCBkPSJNMzc4LTI0NiAxNTQtNDcwbDQzLTQzIDE4MSAxODEgMzg0LTM4NCA0MyA0My00MjcgNDI3WiIvPjwvc3ZnPg==");
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */